import { Button } from "@mui/material";
import React from "react";
import { Link  } from 'react-router-dom'
import { ArrowForwardIos } from "@mui/icons-material"




const Oops = ({section}) =>{

    

    return(
        <div className="oops_wrapper">
                <h2>¡Oh, oh!</h2>
                <div className="oops_heading">
                <img className='result_icon' src={section.icon} />
                <h1>{section.title}</h1>
                </div>
            
                <p>No ha completado esta sección. Para obtener los resultados de ‘{section.title}’ , complete todas las preguntas de esa sección.</p>

                <Button className="oops_button" component={ Link } to={section.path}><span>Ir</span><ArrowForwardIos fontSize="22px"/></Button>

            

        </div>
    )
}

export default Oops